import type { DeepPartial } from '@luna/utils-ts';

import type { Misc } from '../../types/Misc';

export const miscHRFeatureConfig: DeepPartial<Misc> = {
    addTokenToDownloadPayload: true,
};
